import Template from "../templates/UserDetail/UserDetailTemplate";

const UserDetail = () => <Template />;

export default UserDetail;
